"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NotificationEvent = void 0;

var _decorators = require("decorators");

var _messageServer = require("message-server");

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _noty = babelHelpers.interopRequireDefault(require("noty"));

var _Viewer = babelHelpers.interopRequireDefault(require("./Viewer"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _class, _descriptor, _descriptor2, _descriptor3, _temp, _class3;

function hidden(target, name, descriptor) {
  descriptor.enumerable = false;
  return descriptor;
}

var InvalidStateError =
/*#__PURE__*/
function (_Error) {
  babelHelpers.inherits(InvalidStateError, _Error);

  function InvalidStateError() {
    babelHelpers.classCallCheck(this, InvalidStateError);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(InvalidStateError).apply(this, arguments));
  }

  return InvalidStateError;
}(babelHelpers.wrapNativeSuper(Error));

var flagData = {};
var flagPromise = null;

function flagNotifications(id) {
  var isSeen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isNew = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : void 0;
  if (!Array.isArray(id)) id = [id];
  id.forEach(function (id) {
    var fd = flagData[id] || {};
    if (isSeen !== void 0) fd.isSeen = isSeen;
    if (isNew !== void 0) fd.isNew = isNew;
    flagData[id] = fd;
  });

  if (!flagPromise) {
    var P = flagPromise = new Promise(function (resolve, reject) {
      setTimeout(function () {
        if (flagPromise != P) {
          flagPromise.then(resolve, reject);
          return;
        } else {
          flagPromise = null;
        }

        var d = flagData;
        flagData = {};
        (0, _fetch.default)('data/notifications/flag', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: Object.keys(d).map(function (id) {
              return Object.assign({
                id: id
              }, d[id]);
            })
          })
        }).then(function (result) {
          if (result.ok) {
            return true;
          }

          throw result.json();
        }).then(resolve).catch(reject);
      }, 500);
    });
  }

  return flagPromise;
}

var NotificationEvent = (_class = (_temp =
/*#__PURE__*/
function () {
  babelHelpers.createClass(NotificationEvent, [{
    key: "preventDefault",
    value: function preventDefault() {
      if (this.cancelable) this._cancelled = true;
    }
  }, {
    key: "stopImmediatePropagation",
    value: function stopImmediatePropagation() {
      this._stopped = 'now';
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      if (this._stopped == false) this._stopped = true;
    }
  }, {
    key: "cancelBubble",
    get: function get() {
      return this._cancelled;
    },
    set: function set(value) {
      this._cancelled = this.cancelable ? !!value || this._cancelled : false;
    }
  }, {
    key: "defaultPrevented",
    get: function get() {
      return this._cancelled;
    }
  }]);

  function NotificationEvent(type, _ref) {
    var bubbles = _ref.bubbles,
        cancelable = _ref.cancelable,
        data = _ref.data;
    babelHelpers.classCallCheck(this, NotificationEvent);
    this.bubbles = false;
    babelHelpers.initializerDefineProperty(this, "_cancelled", _descriptor, this);
    babelHelpers.initializerDefineProperty(this, "_stopped", _descriptor2, this);
    babelHelpers.initializerDefineProperty(this, "_dispatched", _descriptor3, this);
    this.cancelable = true;
    this.currentTarget = null;
    this.eventPhase = NotificationEvent.AT_TARGET;
    this.originalTarget = null;
    this.target = null;
    this.timeStamp = Date.now();
    this.type = null;
    this.isTrusted = false;
    this.type = type;
    this.bubbles = bubbles;
    this.data = data;
  }

  return NotificationEvent;
}(), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "_cancelled", [hidden], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "_stopped", [hidden], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "_dispatched", [hidden], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
})), _class);
exports.NotificationEvent = NotificationEvent;

var Nothing = function Nothing() {};

var NotificationListener = (_class3 =
/*#__PURE__*/
function () {
  function NotificationListener() {
    babelHelpers.classCallCheck(this, NotificationListener);
    this._feed = {
      account: null,
      items: [],
      feed: [],
      err: [],
      newCount: 0,
      _itemsById: {}
    };
    this.feed = null;
    this._account = null;
    this.visibleNotifications = {};
    if (_exports.default.isServiceWorker || 'Platform_API' in global) return;
    this.addEventListener('login', this.initFeed);
    this.addEventListener('logout', this.initFeed);

    if (global.addEventListener) {
      global.addEventListener('load', this.initFeed, {
        once: true
      });
      $(document).on('profileUpdated', this.initFeed);
    } else {
      this.initFeed();
    }

    this.addEventListener('created', this.createdNotification, {
      passive: true
    });
    this.addEventListener('updated', this.createdNotification, {
      passive: true
    });
    this.addEventListener('removed', this.removedNotification, {
      passive: true
    });
    this.addEventListener('doneUpdateLoop', this.pass2, {
      passive: true
    });
  }

  babelHelpers.createClass(NotificationListener, [{
    key: "pass2",
    value: function pass2(_ref2) {
      var _this = this;

      var data = _ref2.data;
      data.forEach(function (event) {
        // Any that were prevented in the event processing loop below won't have the relevant events dispatched for this loop.
        if (event.defaultPrevented) return;

        if (event.type == event.data.type) {
          _this.dispatchEvent(new NotificationEvent('created', {
            data: event.data
          }));
        } else if (event.type == "updated-".concat(event.data.type)) {
          _this.dispatchEvent(new NotificationEvent('updated', {
            data: event.data
          }));
        } else {
          _this.dispatchEvent(new NotificationEvent('removed', {
            data: event.data
          }));
        }
      });
      this.dispatchEvent(new NotificationEvent('feedUpdated', {
        data: this.feed
      }));
    }
  }, {
    key: "removedNotification",
    value: function removedNotification(event) {
      if (this.visibleNotifications[event.data.id]) {
        this.visibleNotifications[event.data.id].forceClose();
      }
    }
  }, {
    key: "createdNotification",
    value: function createdNotification(event) {
      var notification = event.data;

      if (event.defaultPrevented) {
        return;
      }

      var p = location.search.substring(1).split('&').concat(location.hash.substring(1).split('&')).filter(function (v) {
        return !!v;
      }).map(function (v) {
        return v.split('=').map(decodeURIComponent);
      }).map(function (_ref3) {
        var _ref4 = babelHelpers.toArray(_ref3),
            key = _ref4[0],
            value = _ref4.slice(1);

        return [key, value.join('=')];
      }).reduce(function (acc, _ref5) {
        var _ref6 = babelHelpers.slicedToArray(_ref5, 2),
            key = _ref6[0],
            value = _ref6[1];

        acc[key] = value;
        return acc;
      }, {});

      if (notification.isNew && !notification.isSeen) {
        if (p.notification == notification.id) {
          // The URL parameter 'notification' causes the identified notification to be automatically opened. Don't show a Growl banner for it too.
          this.markSeen([notification.id]);
          return;
        }

        try {
          var NotificationElement = require("components/Notifications/type.".concat(notification.type)).default;

          var n = _react.default.createElement("div", {
            className: "notification-arrow-wrap"
          }, _react.default.createElement(NotificationElement, {
            onSelected: Nothing,
            asLink: false,
            item: notification
          }));

          var hn = this.handleNotification;
          var self = this;

          if (this.visibleNotifications[notification.id]) {
            this.visibleNotifications[notification.id].update(n);
          } else {
            var state = {
              component: n,
              doMark: true,
              shown: false
            };
            var noty = new _noty.default({
              text: '',
              timeout: 6000,
              callbacks: {
                onShow: function onShow() {
                  state.shown = true;

                  _reactDom.default.render(state.component, this.barDom.querySelector('.noty_body'));
                },
                afterClose: function afterClose() {
                  _reactDom.default.unmountComponentAtNode(this.barDom.querySelector('.noty_body'));

                  if (state.doMark) self.markSeen([notification.id]);
                  self.visibleNotifications[notification.id] = null;
                },
                onClick: function onClick() {
                  hn(notification);
                }
              },
              visibilityControl: true
            });
            this.visibleNotifications[notification.id] = {
              state: state,
              noty: noty,
              update: function update(value) {
                state.component = value;

                if (state.shown) {
                  _reactDom.default.render(state.component, noty.barDom.querySelector('.noty_body'));
                }
              },
              forceClose: function forceClose() {
                state.doMark = false;
                noty.close();
              }
            };
            noty.show();
          }
        } catch (e) {}
      }
    }
  }, {
    key: "handleNotification",
    value: function handleNotification(item) {
      var _this2 = this;

      this.markRead(item.id).then(function () {
        if (item.linkTarget) {
          location.href = item.linkTarget;
        } else {
          var v = new _Viewer.default();
          v.setNotifications(_this2.feed, item.id);
          v.show();
        }
      });
    }
  }, {
    key: "showNotificationOverlay",
    value: function showNotificationOverlay(id) {
      this.dispatchEvent(new NotificationEvent('openNotification', {
        data: id
      }));
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, callback) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      NotificationListener._addEventListener(this, type, callback, options);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, callback) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      NotificationListener._removeEventListener(this, type, callback, options);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      return NotificationListener._dispatchEvent(this, event);
    }
  }, {
    key: "fetchFeed",
    value: function fetchFeed() {
      var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._streamingFetchFeed(initial);
    }
  }, {
    key: "_initialFeedProcess",
    value: function _initialFeedProcess(data) {
      if (data.nextPage && data.hasMoreNewItems) {
        return this._doContinuedFeedFetch(data);
      }

      return {
        status: 200,
        ok: true,
        json: function json() {
          return Promise.resolve(data);
        }
      };
    }
  }, {
    key: "_doContinuedFeedFetch",
    value: function _doContinuedFeedFetch(previous) {
      return (0, _fetch.default)('data/notifications/feed?startFrom=' + previous.nextPage).then(function (result) {
        return result.json();
      }).then(function (data) {
        var x = Object.assign({}, previous);
        x.feed = x.feed.concat(data.feed);
        x.nextPage = data.nextPage;
        x.hasMoreNewItems = data.hasMoreNewItems;
        x.newCount += data.newCount;
        return x;
      }).then(this._initialFeedProcess);
    }
  }, {
    key: "_doInitialFeedFetch",
    value: function _doInitialFeedFetch() {
      return (0, _fetch.default)('data/notifications/feed').then(function (result) {
        return result.json();
      }).then(this._initialFeedProcess);
    }
  }, {
    key: "fetchMore",
    value: function fetchMore() {
      var _this3 = this;

      if (this._feed.nextPage) {
        if (this.timeout) clearTimeout(this.timeout);

        this._doContinuedFeedFetch(this._feed).then(function (result) {
          if (result.status == 200) {
            result.json().then(function (feed) {
              _this3.processFeed(feed, false, true);
            });
          } else {
            _this3.timeout = setTimeout(function () {
              _this3.fetchMore();
            }, 15000 + Math.random() * 60000);
          }
        });
      }
    }
  }, {
    key: "_normalFetchFeed",
    value: function _normalFetchFeed() {
      var _this4 = this;

      var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      clearTimeout(this.timeout);
      var ds;

      if (initial) {
        ds = this._doInitialFeedFetch();
      } else {
        ds = (0, _fetch.default)("data/notifications/feed?since=".concat(encodeURIComponent(this._feed.timeStamp)));
      }

      ds.then(function (result) {
        if (result.ok) {
          result.json().then(function (feed) {
            return _this4.processFeed(feed, initial);
          });
        }

        _this4.timeout = setTimeout(function () {
          _this4.fetchFeed();
        }, 15000 + Math.random() * 60000);
      });
    }
  }, {
    key: "_streamingFetchFeed",
    value: function _streamingFetchFeed() {
      var _this5 = this;

      var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (initial) {
        clearTimeout(this.timeout);

        if (this.eventSource) {
          this.eventSource.close();
        }

        var ds = this._doInitialFeedFetch();

        ds.then(function (result) {
          if (result.status == 200) {
            result.json().then(function (feed) {
              _this5.processFeed(feed, initial);

              _this5.startStream();
            });
          } else {
            _this5.timeout = setTimeout(function () {
              _this5.fetchFeed(true);
            }, 15000 + Math.random() * 60000);
          }
        });
      }
    }
  }, {
    key: "startStream",
    value: function startStream() {
      if (this._feed.account) {
        if (_messageServer.message_server_url) {
          this.eventSource = new EventSourceImpl(_messageServer.message_server_url + "/notifications-" + this._feed.account);
          this.eventSource.onmessage = this.streamingMessage;
          this.eventSource.start();
        }
      }
    }
  }, {
    key: "initFeed",
    value: function initFeed() {
      this.fetchFeed(true);
    }
  }, {
    key: "streamingMessage",
    value: function streamingMessage(event) {
      var _this6 = this;

      var events = [];
      console.log(event);

      switch (event.type) {
        case 'deleted':
        case 'removed':
          var toRemove = this._feed._itemsById[JSON.parse(event.data)];

          if (toRemove) {
            events.push(new NotificationEvent("removed-".concat(toRemove.type), {
              data: toRemove
            }));
            this._feed.feed = this._feed.feed.filter(function (node) {
              return node.id != toRemove.id;
            });
            delete this._feed._itemsById[event.data];

            this._feed.items.splice(this._feed.items.indexOf(event.data));

            this._feed.timeStamp = new Date().toJSON();
          }

          break;

        case 'created':
        case 'updated':
          var newItem = JSON.parse(event.data);
          if (newItem === false) break;
          if ('freeze' in newItem) newItem.freeze();
          this._feed._itemsById[newItem.id] = newItem;

          if (this._feed.items.indexOf(newItem.id) == -1) {
            // events.push(new NotificationEvent('created', { data: newItem }));
            events.push(new NotificationEvent(newItem.type, {
              data: newItem
            }));
          } else {
            // events.push(new NotificationEvent(`updated`, { data: newItem }));
            events.push(new NotificationEvent("updated-".concat(newItem.type), {
              data: newItem
            }));
          }

          this._feed.items = this._feed.items.filter(function (id) {
            return id != newItem.id;
          }).concat(newItem.id);
          this._feed.feed = this._feed.feed.filter(function (item) {
            return item.id != newItem.id;
          }).concat(newItem);
          break;
      }

      if (events.length) {
        this._feed.feed.sort(function (left, right) {
          return new Date(right.time).getTime() - new Date(left.time).getTime();
        });

        this._feed.newCount = this._feed.feed.filter(function (item) {
          return item.isNew;
        }).length;
        this.feed = Object.assign({}, this._feed);
        events.push(new NotificationEvent('feedUpdated', {
          data: this.feed
        }));
        events.push(new NotificationEvent('doneUpdateLoop', {
          data: events.slice()
        }));
        console.log(events);
      }

      events.forEach(function (event) {
        return _this6.dispatchEvent(event);
      });
    }
  }, {
    key: "processFeed",
    value: function processFeed(feed) {
      var _this7 = this;

      var initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isFetchMore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var events = [];
      this._feed.nextPage = feed.nextPage;
      this._feed.timeStamp = feed.timeStamp;

      if (this._feed.account != feed.account) {
        if (feed.account) events.push(new NotificationEvent('login', {
          data: {
            userId: feed.account
          }
        }));else events.push(new NotificationEvent('logout', {
          data: {
            userId: this._feed.account
          }
        }));
        this._feed.account = feed.account;
      }

      var removedItems = this._feed.items.filter(function (item) {
        return feed.items.indexOf(item) == -1;
      });

      this._feed.items = this._feed.items.filter(function (item) {
        return feed.items.indexOf(item) != -1;
      });
      removedItems.forEach(function (item) {
        events.push(new NotificationEvent("removed-".concat(_this7._feed._itemsById[item].type), {
          data: _this7._feed._itemsById[item]
        }));
        _this7._feed.feed = _this7._feed.feed.filter(function (node) {
          return node.id != item;
        });
        delete _this7._feed._itemsById[item];
      });
      feed.feed.forEach(function (item) {
        if ('freeze' in item) item.freeze();

        if (_this7._feed.items.indexOf(item.id) == -1) {
          events.push(new NotificationEvent(item.type, {
            data: item
          })); // events.push(new NotificationEvent('created', { data: item }));

          _this7._feed.items.push(item.id);

          _this7._feed.feed.push(item);
        } else {
          events.push(new NotificationEvent('updated-' + item.type, {
            data: item
          }));
          _this7._feed.feed = _this7._feed.feed.map(function (node) {
            if (node.id == item.id) return item;
            return node;
          }); // events.push(new NotificationEvent('updated', { data: item }));
        }
      });

      if (events.length) {
        this._feed.feed.sort(function (left, right) {
          return new Date(right.time).getTime() - new Date(left.time).getTime();
        });

        this._feed.newCount = this._feed.feed.filter(function (item) {
          return item.isNew;
        }).length;
        this.feed = Object.assign({}, this._feed);
        events.push(new NotificationEvent('feedUpdated', {
          data: this.feed
        }));
        events.push(new NotificationEvent('doneUpdateLoop', {
          data: events.slice()
        }));
      }

      events.forEach(function (event) {
        return event.isFetchMore = true;
      });
      events.forEach(function (event) {
        return _this7.dispatchEvent(event);
      });
    }
  }, {
    key: "markSeen",
    value: function markSeen(ids) {
      var _this8 = this;

      if (ids.length == 0) {
        return Promise.resolve(true);
      }

      ids = ids.filter(function (item) {
        return _this8._feed.feed.filter(function (feed) {
          return feed.id == item && !feed.isSeen;
        }).length;
      });
      return flagNotifications(ids, true, void 0).then(function (value) {
        _this8.fetchFeed();

        return true;
      });
    }
  }, {
    key: "markRead",
    value: function markRead(id) {
      var _this9 = this;

      if (!Array.isArray(id)) id = [id];
      return flagNotifications(id, true, false).then(function (value) {
        _this9.fetchFeed();

        return true;
      });
    }
  }, {
    key: "markAllRead",
    value: function markAllRead() {
      return this.markRead(this._feed.feed.filter(function (item) {
        return item.isNew;
      }).map(function (item) {
        return item.id;
      }));
    }
  }], [{
    key: "_addEventListener",
    value: function _addEventListener(target, type, callback) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var _Object$assign = Object.assign({
        passive: false
      }, options),
          passive = _Object$assign.passive;

      if (!target._events) target._events = {};
      if (!target._events[type]) target._events[type] = [];
      if (target._events[type].filter(function (v) {
        return v.callback == callback && v.passive == passive;
      }).length) return;

      target._events[type].push({
        callback: callback,
        passive: passive
      });
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(type, callback) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      NotificationListener._addEventListener(NotificationListener, type, callback, options);
    }
  }, {
    key: "_removeEventListener",
    value: function _removeEventListener(target, type, callback) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var _Object$assign2 = Object.assign({
        passive: false
      }, options),
          passive = _Object$assign2.passive;

      if (!target._events) target._events = {};

      if (target._events[type]) {
        target._events[type] = target._events[type].filter(function (v) {
          return !(v.callback == callback && v.passive == passive);
        });

        if (!target._events[type].length) {
          delete target._events[type];
        }
      }
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, callback) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      NotificationListener._removeEventListener(NotificationListener, type, callback, options);
    }
  }, {
    key: "_dispatchEvent",
    value: function _dispatchEvent(target, event) {
      if (event._dispatched) throw new InvalidStateError("Trying to call dispatchEvent() on an already processed NotificationEvent object.");
      var type = event.type;
      event._dispatched = true;
      event.target = event.currentTarget = event.originalTarget = target;
      event.bubbles = false;
      event.isTrusted = false;
      if (!target._events) target._events = {};
      var passive = [];

      if (target._events[type]) {
        var x = target._events[type];

        for (var i = 0; i < x.length; i++) {
          var f = x[i];

          try {
            if (f.passive) passive.push(f.callback);else {
              var rv = f.callback.call(target, event);
              if (rv === false) event.preventDefault();
            }
          } catch (e) {
            ;
          }

          if (event._stopped == 'now') {
            return event.cancelable ? !event._cancelled : true;
          }
        }
      }

      if (passive.length) {
        Promise.resolve(passive).then(function (passive) {
          passive.forEach(function (handler) {
            handler.call(target, event);
          });
        });
      }

      return event.cancelable ? !event._cancelled : true;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(event) {
      return NotificationListener._dispatchEvent(NotificationListener, event);
    }
  }]);
  return NotificationListener;
}(), (babelHelpers.applyDecoratedDescriptor(_class3.prototype, "pass2", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "pass2"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "removedNotification", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "removedNotification"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "createdNotification", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "createdNotification"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "handleNotification", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "handleNotification"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_initialFeedProcess", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_initialFeedProcess"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "_doContinuedFeedFetch", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "_doContinuedFeedFetch"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "initFeed", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "initFeed"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "streamingMessage", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "streamingMessage"), _class3.prototype)), _class3);
var Instance = new NotificationListener();
var _default = Instance;
exports.default = _default;